import { render, staticRenderFns } from "./DniValidatorMixin.vue?vue&type=template&id=7b0760ca&lang=pug"
import script from "./DniValidatorMixin.vue?vue&type=script&lang=ts"
export * from "./DniValidatorMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b0760ca')) {
      api.createRecord('7b0760ca', component.options)
    } else {
      api.reload('7b0760ca', component.options)
    }
    module.hot.accept("./DniValidatorMixin.vue?vue&type=template&id=7b0760ca&lang=pug", function () {
      api.rerender('7b0760ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/mixins/DniValidatorMixin.vue"
export default component.exports